var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"datos-cliente"},[_c('fai',{staticClass:"fa-2x align-middle",attrs:{"icon":"user-circle"}}),_vm._v(" "+_vm._s(_vm.cliente.nombre)+" "+_vm._s(_vm.cliente.numDoc)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }